import { useCallback, useEffect, useState } from "react";
import { Clapperboard } from "lucide-react";
import { Header } from "@/pages/Operations";
import { RenderComposer } from "@/components/render/RenderComposer";
import { MovieComposer } from "@/components/render/MovieComposer";
import { RenderList } from "@/components/render/RenderList";
import api from "@/lib/api";

export default function Renders() {
  const [jobs, setJobs] = useState([]);
  const [caps, setCaps] = useState(null);
  const load = useCallback(() => api.get("/render/jobs").then((r) => setJobs(r.data)).catch(() => {}), []);
  useEffect(() => {
    api.get("/render/capabilities").then((r) => setCaps(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, [load]);
  return (
    <div data-testid="renders-page">
      <Header icon={Clapperboard} eyebrow="Render Studio · GPU jobs" title="Pick a mode. See the cost. Hit Generate."
        subtitle="Every job reserves credits up-front, shows live status (Queued → Rendering → Done) and refunds automatically if it fails. GPU endpoints run on RunPod; if one is not connected the job falls back to our current engine." />
      {caps && (
        <div data-testid="render-provider-strip" className="flex flex-wrap gap-1.5 mb-5 text-[10px] font-mono">
          {Object.entries(caps.job_types).map(([k, v]) => (
            <span key={k} data-testid={`provider-${k}`} className={`px-2 py-1 rounded-md border ${v.provider === "runpod" ? "border-emerald-500/40 text-emerald-300" : v.provider === "fallback" ? "border-amber-500/30 text-amber-200" : "border-white/10 text-slate-500"}`}>
              {k} · {v.provider === "runpod" ? "GPU" : v.provider === "fallback" ? `fallback: ${v.fallback_engine}` : "not connected"}
            </span>
          ))}
          <span className="px-2 py-1 rounded-md border border-white/10 text-slate-400">storage: {caps.storage === "r2" ? "Cloudflare R2" : "local"}</span>
        </div>
      )}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <RenderComposer caps={caps} onCreated={load} />
        <MovieComposer caps={caps} onCreated={load} />
      </div>
      <RenderList jobs={jobs} onChange={load} />
    </div>
  );
}
